export default "__VITE_ASSET__1195ba28__"